import { render, staticRenderFns } from "./Reproductions.vue?vue&type=template&id=4dfd0615&scoped=true&"
import script from "./Reproductions.vue?vue&type=script&lang=ts&"
export * from "./Reproductions.vue?vue&type=script&lang=ts&"
import style0 from "./Reproductions.vue?vue&type=style&index=0&id=4dfd0615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd0615",
  null
  
)

export default component.exports